import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { atsEmbedSx } from '../styles';

type AtsMessageProps = {
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
};

export const AtsMessage: React.FC<AtsMessageProps> = ({
  title,
  body,
  actionLabel,
  onAction
}) => (
  <Box sx={atsEmbedSx.message}>
    <Typography variant="h5">{title}</Typography>
    <Typography color="text.secondary">{body}</Typography>
    {actionLabel && onAction && (
      <Button variant="primary" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </Box>
);
